import { render } from 'preact';
import type { Dataset } from '@life/data';
import { App } from './app';
import { registerSW } from 'virtual:pwa-register';
import { boot } from './state/boot';
import datasetUrl from '../../../packages/data/dist/countries.v1.json?url';
import './styles/tokens.css';
import './styles/base.css';

/**
 * Датасет стран подключается как asset (ссылка, не inline в бандл) и читается
 * один раз при старте. Схема проверена при сборке данных, поэтому в браузере
 * JSON берётся как есть — `@life/data` в рантайме клиента не импортируется
 * (его index тянет node:fs).
 */
async function loadDataset(): Promise<Dataset> {
  const res = await fetch(datasetUrl);
  if (!res.ok) throw new Error(`dataset: HTTP ${res.status}`);
  return (await res.json()) as Dataset;
}

async function main(): Promise<void> {
  const root = document.getElementById('app');
  if (!root) return;
  const ds = await loadDataset();
  const { game, loadError } = boot(ds, undefined, location.search);
  render(<App game={game} ds={ds} loadError={loadError} />, root);
}

// PWA: service worker обновляется сам, без вопросов игроку.
registerSW({ immediate: true });
void main();
